import FolderCard from '../../../FolderCard';
import { getSubfoldersByParentId } from '../../selectors';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { setCurrentFolderId } from '../../actions';
const mapStateToProps = (state, ownProps)=>{
    const subfolders = getSubfoldersByParentId(state, ownProps.folder.folderId);
    return {
        hasSubfolders: subfolders && subfolders.length > 0,
        withLink: false
    };
};
const mapDispatchToProps = (dispatch, ownProps)=>({
        onClick: ()=>dispatch(setCurrentFolderId(ownProps.folder.folderId))
    });
export default withMobileContext(connectMediaStore(mapStateToProps, mapDispatchToProps)(FolderCard));
